import React from 'react';

import InteractionsBox from '../../../Shared/InteractionsBox';
import StickyFooterWrapper from '../../StickyFooterWrapper';

function Footer({ post, space }: any) {
  return (
    <StickyFooterWrapper>
      <InteractionsBox
        post={post}
        space={space}
        direction="row"
        ctaVariant="outlined"
        isResponsive
        onlyPrimaryActions
        size="small"
      />
    </StickyFooterWrapper>
  );
}

export default Footer;
